module.exports = __webpack_public_path__ + "img/upload-icon.e2857be5.png";